import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CalendlyComponent } from './calendly.component';

@NgModule({
  imports: [ CommonModule, FormsModule, IonicModule,],
  declarations: [CalendlyComponent],
  exports: [CalendlyComponent]
})
export class CalendlyComponentModule {}
